import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { Tooltip, TooltipContent, TooltipTrigger } from '@e2n/ui';
import { Column } from '@tanstack/react-table';
import { TerminKalender } from '@/domain/termine/shared/types/TerminKalender';
import { getSortIcon } from '@/domain/termine/features/TerminKalender/Desktop/Table/utils/getSortIcon';

export function ApiKeyColumnHeader({
  column,
}: {
  column: Column<TerminKalender>;
}) {
  const { t } = useTranslation();

  return (
    <div
      className="flex items-center gap-1 cursor-pointer select-none"
      onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}>
      {t('domain.termine.kalender.table.apiKey')}
      <Tooltip>
        <TooltipTrigger asChild>
          <span onClick={(e) => e.stopPropagation()}>
            <FontAwesomeIcon
              icon={faCircleInfo}
              className="text-neutrals-700 cursor-default p-1 rounded-md w-4 h-4"
            />
          </span>
        </TooltipTrigger>
        <TooltipContent
          side="bottom"
          className="bg-white p-3 rounded-md text-xs shadow-xs border border-neutrals-300 text-neutrals-900 max-w-64">
          {t('domain.termine.kalender.table.apiKeyTooltip')}
        </TooltipContent>
      </Tooltip>
      <FontAwesomeIcon
        icon={getSortIcon(column.getIsSorted())}
        className="text-neutrals-400"
      />
    </div>
  );
}
